export default __webpack_public_path__ + "static/media/product-2.860dfdd5.JPG";